services.service('WithdrawHistoryService', ['$q', 'API', 'constants', 'UserService',
    'TransactionHistoryCollection', 'WithdrawRequestModel',
    function ($q, API, Const, UserService, TransactionHistoryCollection, WithdrawRequestModel) {
        var self = this;

        self.user = null;
        self.collection = null;

        this.init = function () {
            self.user = UserService.get();
        };

        this.getWithdrawalRequests = function() {
            if (self.user.activeTradingAccount) {
                return API.withdrawalHistory()
                    .then(checkResponse)
                    .then(function (response) {
                        initCollection();
                        return response;
                    })
                    .then(initTransactions)
            }

            initCollection();
            return $q.resolve();
        };

        this.cancelWithdrawalRequest = function(id) {
            var request = {id: id};
            return API.withdrawalCancel(request)
                .then(checkResponse)
                .then(function(response) {
                    var withdrawRequest = self.collection.get({id: id});
                    withdrawRequest.status = 'cancelledByCustomer';
                });
        };

        this.clear = function() {
            self.collection && self.collection.clear();
            self.collection = null;
        };

        //region Private fns
        function initTransactions(data) {
            data.withdrawalRequests.forEach(function(withdrawRequest) {
                self.collection.add(new WithdrawRequestModel(withdrawRequest))
            })
        }

        function initCollection() {
            // TransactionHistoryCollection is essentially a wrapper, there is no need to create new collection model
            self.collection = new TransactionHistoryCollection();
        }

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'WithdrawHistoryService',
                    type: Const.error.type.SYSTEM,
                    code: data.code,
                    severity: 'critical',
                    data: {response: data}
                });
            }
            return data;
        }
        //endregion

        return this;
    }]);